import { useContentStore } from "../../providers/stores/content-store";
import { useState } from "react";
import { isNullOrEmpty, isNullOrUndefined } from '../../helpers';
import { ValidationMessages } from '../common/ValidationMessages';
import { AccountApi } from "../../api";

import logger from 'debug';

const debug = logger('login:passwordReminderPage');

export const PasswordReminder = () => {
	const authenticationContent = useContentStore(state => state.authenticationContent(state));
	const sharedContent = useContentStore(state => state.sharedContent(state));

	const [userName, setUserName] = useState('');
	const [validation, setValidation] = useState([]);
	const [isSuccess, setIsSuccess] = useState(false);

	const onSubmit = async (event) => {
		event.preventDefault();

		const apiResponse = await AccountApi.passwordReminder({ userName });

		// success
		if (isNullOrUndefined(apiResponse.error)) {
			debug('isSuccess is true');
			setIsSuccess(true);
			setValidation(apiResponse.messages);
		}
		else {
			const { data, error } = apiResponse;
			let response = JSON.parse(data);
			debug('response.text(): ', JSON.stringify(data));
			debug('error: ', JSON.stringify(error));
			setValidation(response.messages);
		}
	}

	return (
		<div className="forgotCredentials">
			<form id="password-form" onSubmit={onSubmit} className="pad20 clearfix" >
				<h1>Reset Password</h1>

				<label>{authenticationContent.userNameLabel}</label>
				<div className="textWrapper">
					<input value={userName} onChange={(event) => setUserName(event.target.value)} />
				</div>
				<div>Enter the user name associated with your account.</div>

				{!isNullOrEmpty(validation) &&
					<ValidationMessages
						className={isSuccess ? '' : ''}
						header={isSuccess ? '' : 'Error(s):'}
						messages={validation} />
				}
				<button type="submit">{sharedContent.submitButton}</button>
			</form>

			<div className="junkMessage" dangerouslySetInnerHTML={{ __html: authenticationContent.messageJunkFilter }} />
		</div>
	);
};